import styled from "styled-components";

export const StyledApp = styled.div`

  .order-id {
    font-size: 14px;
    color: #3B444D;
    font-weight: 500;
    flex-shrink: 0;
  }

  .request-date,
  .return-id {
    font-size: 12px;
    color: #3B444Db2;
    margin-top: 0px;
  }

  @media (min-width: 800px) {
    font-size: 14px;

    .order-id {
      font-size: 1.5rem;
    }

    .request-date,
    .return-id {
      font-size: 14px;
      margin-top: 6px;
    }
  }

  @media (min-width: 600px) {
    .step-content {
      display: flex;
      justify-content: center;
      margin-left: -10px;
      border-left: none;
    }
  }
`;

export const StyledTracking = styled.div`
  padding: 80px 5.5%;

  .shipment-accordion {
    p,
    svg {
      font-size: 14px;
    }

    .description {
      color: #3B444D;
      font-size: 10px;
    }
  }

  .help {
    font-size: 12px;
  }
  @media (min-width: 800px) {
    padding: 120px 5.5%;
    .shipment-accordion {
      p,
      svg {
        font-size: 16px;
      }
    }
    .help {
      font-size: 16px;
    }
  }
`;

export const StyledComments = styled.div`
  position: fixed;
  bottom: 0;
  right: 1rem;
  z-index: 999;

  .comments-header {
    display: flex;
    align-items: center;
    padding: 10px;
    min-width: 300px;
    background: #fff;
    cursor: pointer;
  }

  .commented-merchant {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    float: right;
  }

  .commented-customer {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    float: left;
  }

  .comment-merchant {
    background: #1d8dcc33;
    border: 1px solid #1d8dcc;
    padding: 12px;
    border-radius: 1px 14px 14px 14px;
    max-width: 90%;
    margin-top: 1rem;
  }

  .comment-customer {
    background: #fff;
    border: 1px solid #1d8dcc;
    text-align: right;
    padding: 12px;
    border-radius: 14px 1px 14px 14px;
    max-width: 90%;
    margin-top: 1rem;
    margin-right: 10px;
  }

  @media (min-width: 800px) {
    right: 100px;

    .comments-header {
      min-width: 400px;
    }
  }
`;

export const StyledExchangePaymentDetails = styled.div`
  .exchange-details-heading {
    font-size: 14px;
    font-weight: 700;
    margin: 10px 0px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .payment-status {
      text-transform: capitalize;
      font-weight: 500;
      padding: 2px 8px;
      font-size: 12px;
      margin-left: 6px;
    }
  }

  button {
    font-size: 14px;
    margin-top: 1rem;
  }
  .payment-details {
    display: flex;
    flex-direction: column;
    font-size: 13px;
  }

  .exchange-details-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    margin-top: 10px;
    width: 100%;
  }

  @media (min-width: 800px) {
    .exchange-details-heading {
      font-size: 18px;

      .payment-status {
        font-size: 1rem;
      }
    }

    .payment-details {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      margin-top: 6px;
    }
  }
`;
